<template>
    <div>
        <!-- Share modal -->
        <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h6 class="modal-title">Share Pool</h6>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div>
                        <div class="">
                            <div class="row">
                                <div class="col-12 p-0">
                                    <div class="d-flex container" ref="container">
                                        <input type="text" class="form-control form-control-sm form-control-plaintext mr-2 pl-2" v-model="poolLink" readonly>
                                        <button type="button" class="btn btn-light text-dark font-weight-bold" @click="doCopy">Copy!</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mt-4 d-md-flex justify-content-between">
                        <!-- <a :href="`https://wa.me/?text=${poolLink}`" data-action="share/whatsapp/share" class="btn btn-link btn-sm" target="_blank">Share On WhatsApp</a> -->
                        <a :href="`https://telegram.me/share/url?url=${poolLink}&text=View this MoneyPool`" class="btn btn-link btn-sm" target="_blank">Share on Telegram</a>

                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-light btn-sm" data-dismiss="modal">Close</button>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        poolLink: {
            type: String,
            required: true
        }
    },

    methods: {
        doCopy: function () {
            let container = this.$refs.container;
            let self = this;

            this.$copyText(this.poolLink, container).then(function (e) {

                self.$notify({
                    group: 'foo',
                    type: 'success',
                    title: 'Success',
                    text: 'Text Copied!'
                });
            }, function (e) {

                self.$notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Error',
                    text: 'Couldn\'t be Copied!'
                });
            })
        }
    }
}
</script>

<style>

</style>